var _excluded = ["aria-disabled", "children", "disabled", "href", "loading", "onClick"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { getBooleanishTruthy } from '@brandfolder/utilities';
import React, { forwardRef } from 'react';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseLink = /*#__PURE__*/forwardRef(function (props, ref) {
  var ariaDisabled = props['aria-disabled'],
    children = props.children,
    disabled = props.disabled,
    href = props.href,
    loading = props.loading,
    onClick = props.onClick,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isDisabled = getBooleanishTruthy(ariaDisabled) || disabled || undefined;
  return /*#__PURE__*/React.createElement("a", _extends({}, otherProps, {
    "aria-disabled": isDisabled,
    href: !isDisabled && !loading ? href : undefined,
    onClick: !isDisabled && !loading ? onClick : undefined,
    ref: ref
  }), children);
});
export { BaseLink };